'use strict';

var _Recommendation = require('./Recommendation');

var _Recommendation2 = _interopRequireDefault(_Recommendation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External Dependencies
var get = require('lodash/get');
var StandardError = require('standard-error');
// Internal Dependencies
var leadStatuses = require('../enums/leadStatuses');
var CONCIERGE_ENUMS = require('../enums/concierge');
var bookingRequestStates = require('../enums/bookingRequestState');

var _require = require('../enums/concierge'),
    LEAD_BUDGET_MAP = _require.LEAD_BUDGET_MAP;

// Helpers


/**
 * Displays a lead's phone number
 * @param {Lead}
 * @return {String}
 */

exports.phoneNumber = function (lead) {
  if (!get(lead, 'profile.phone.areaCode') | !get(lead, 'profile.phone.number')) {
    return undefined;
  }
  return get(lead, 'profile.phone.areaCode') + '-' + get(lead, 'profile.phone.number');
};

exports.currentStatus = function (lead) {
  return leadStatuses.filter(function (ls) {
    return get(lead, 'statuses.' + ls + '.value');
  }).pop() || '';
};

exports.dashboardLink = function (lead, config) {
  return config.domain + '/admin/lead/' + lead._id.toString();
};

exports.recosUrl = function (lead, config) {
  return config.domain + '/recos/' + lead._id.toString();
};

exports.createActivityIndicator = function (_ref) {
  var recommendations = _ref.recommendations;

  if (!recommendations) {
    throw new StandardError('No recommendations provided');
  }
  var startingActivityIndicator = {
    sendProposal: 0,
    totalSendProposals: 0,
    notGoodFit: 0,
    notSure: 0,
    comments: 0,
    recoBR: 0,
    incompleteBRs: 0,
    bookingRequests: 0,
    unrespondedCAWPs: 0,
    unrespondedBRs: 0
  };

  return recommendations.reduce(function (activityIndicator, recommendation) {
    return _Recommendation2.default.updateActivityIndicator({ recommendation: recommendation, activityIndicator: activityIndicator });
  }, startingActivityIndicator);
};

exports.numberOfProposalsSent = function (_ref2) {
  var recommendations = _ref2.recommendations,
      active = _ref2.active;

  var statesToCheck = active ? bookingRequestStates.activeSentProposalStates : bookingRequestStates.sentProposalStates;
  return recommendations.reduce(function (counter, recommendation) {
    var state = get(recommendation, 'conversation.requestState');
    if (statesToCheck.includes(state)) {
      counter++;
    }
    return counter;
  }, 0);
};

exports.budget = function (lead) {
  var totalEventBudgetDollars = lead.request.totalEventBudgetDollars;
  var budgetPerGuest = lead.request.budgetPerGuest;
  var minGuests = lead.request.numGuests.min;
  var maxGuests = lead.request.numGuests.max;
  var avgGuests = void 0;
  if (minGuests && maxGuests) {
    avgGuests = (minGuests + maxGuests) / 2;
  } else {
    avgGuests = maxGuests || minGuests;
  }

  if (totalEventBudgetDollars) {
    return totalEventBudgetDollars;
  } else {
    var budgetPerGuestDollars = LEAD_BUDGET_MAP[budgetPerGuest];
    return budgetPerGuestDollars * avgGuests;
  }
};

exports.prioritize = function (lead) {
  var level = get(lead, 'admin.priorityValue');
  var priorities = CONCIERGE_ENUMS.priorityLevels;
  return priorities[level] || null;
};

exports.getPrimaryClient = function (lead) {
  if (lead.clients.length) {
    var primaryUser = lead.clients.find(function (client) {
      return client.isPrimary;
    });
    return primaryUser.user || primaryUser;
  }
};